import React, { useState } from "react";
import HRTitleHeader from "src/components/ui/HRTitleHeader";
import Policies from "./policies/Policies";
import AppraisalLetter from "./letters/AppraisalLetter";
import LetterSelector from "./letters/LetterSelector";

const ComplianceReports: React.FC = () => {
    
  return (
    <div>
      {/* Header */}
      <HRTitleHeader
        title="Compliances & Reports"
        info="Download statutory reports and compliance summaries"
      />

      {/* Card */}
      <Policies />
      <LetterSelector/>
  
      </div>
  
  );
};

export default ComplianceReports;
